import React from 'react';
import { Column, Divider } from '~/commonComponents';
import { ProcessStep } from './ProcessStep';

export const ProcessStepsSection: React.FC = () => {
  return (
    <Column
      maxWidth={980}
      paddingTop={16}
      gap={40}
      marginTop={40}
      marginBottom={60}
      justifyContent="center"
      alignSelf="center"
    >
      <Column gap={40}>
        <ProcessStep
          title="Post a Shift"
          description="Create and post a shift in minutes. You choose the professional type, date, hours, and hourly rate. Once posted, your shift will be shown to our network of licensed dental professionals in your area who match your needs. Professionals can apply directly, and you review their profiles before confirming the best fit."
        />

        <Divider width={360} height={2} marginVertical={0} />
      </Column>

      <Column gap={40}>
        <ProcessStep
          title="Review and Confirm Candidates"
          description="Browse candidates who’ve applied, view their licenses, experience, and ratings. Confirm the best fit, or save time by using GoTu’s auto-confirm feature to match you with a qualified professional who’s ready to work. Every professional is pre-screened and verified."
          width={864}
        />
        <Divider width={360} height={2} marginVertical={0} />
      </Column>

      <Column gap={40}>
        <ProcessStep
          title="Shift Completed, Payment Handled"
          description="When the shift ends, you’ll be prompted to either confirm or adjust the professional’s hours. Once submitted, we’ll process the payment to the professional, no need for invoices or back-and-forth. It’s that easy. Focus on patient care while we handle the administrative work."
        />
        <Divider width={360} height={2} marginVertical={0} />
      </Column>

      <ProcessStep
        title="Rate and Re-Book"
        description="At the end of each shift, rate the professional and add them to your Favorites. You can easily access your list in the Professionals Hub to reconnect and send invites with just a few clicks. GoTu helps you build your dental dream team, one great connection at a time."
      />
    </Column>
  );
};
